var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"small-timeseries"},[_c('vue-plotly',{attrs:{"data":_vm.data,"layout":_vm.layout,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }